/*
 * @Descripttion:
 * @Author: zhanghang
 * @Date: 2022-07-27 11:31:25
 * @LastEditors: zhanghang
 * @LastEditTime: 2023-11-22 17:37:55
 */
import {
  utilsHandleScope,
  utilsHandleParseCode,
} from "_dataview/output/utils/event";
export default {
  mixins: [$mixins.control],
  props: {
    //是否是大屏组件
    isDataViewControl: {
      type: Boolean,
      default: true,
    },
    //伪代码方法对象-字符串
    executeFnScope: {
      type: String,
      default: "",
    },
    //伪代码中文组件映射对象
    executeFnComp: {
      type: Object,
      default() {
        return {};
      },
    },
    //伪代码对应组件名字
    fakeCodeName: {
      type: String,
      default() {
        return "";
      },
    },
    fontSize: {
      type: [String, Number],
      default: 16,
    },
    fontWeight: {
      type: [String, Number],
      default: 500,
    },
    excelData: {
      type: Array,
      default: () => [],
    },
    padding: {
      type: Array,
      default: () => [0, 0, 0, 0],
    },
    margin: {
      type: Array,
      default: () => [0, 0, 0, 0],
    },
    height: {
      type: String,
      default: "100%",
    },
    width: {
      type: String,
      default: "100%",
    },
  },
  watch: {
    height: {
      handler(v) {
        if (this.isDesign) {
          let height = v;
          if (!v) {
            height = "auto";
          }
          if (dsf.isNumber(height) || /^\d+$/g.test(height)) {
            height += "px";
          }
          this.$dispatch("design-height-change", height);
        }
        this.$nextTick(() => {
          this.resize && this.resize();
        });
      },
      immediate: true,
    },
    margin: {
      handler(v) {
        if (this.isDesign) {
          let margin = v;
          let marginTop = 0;
          let marginBottom = 0;
          if (Array.isArray(margin)) {
            marginTop = this.transPX(margin[0]);
            marginBottom = this.transPX(margin[2]);
          } else {
            marginTop = this.transPX(margin);
            marginBottom = this.transPX(margin);
          }

          this.$dispatch(
            "design-margin-change",
            `${marginTop} 0 ${marginBottom} 0`
          );
        }
      },
      immediate: true,
    },
  },
  computed: {
    fontStyle() {
      return {
        fontSize: this.transFontSize,
      };
    },
    transFontSize() {
      return this.transPX(this.fontSize);
    },
    controlHeight() {
      let { height, width } = this;
      width = this.transPX(width);
      if (!this.isDesign) {
        return {
          height: this.transPX(height),
          width,
        };
      }
      return {
        width,
      };
    },
    marginAndPadding() {
      let { padding: paddingArray, margin: marginArray } = this;
      let padding = ""
      if (this.isDesign) {
        paddingArray = paddingArray.map(size => {
          if ((dsf.isNumber(size) || /^\d+$/g.test(size))) {
            if (size < 8) {
              return 8
            }
          }
          return size
        })
        padding = this.handleArrPX(paddingArray);
        marginArray = [0, marginArray[1], 0, marginArray[3]];
      } else {
        padding = this.handleArrPX(paddingArray);
      }

      let margin = this.handleArrPX(marginArray);
      return {
        padding,
        margin,
      };
    },
    controlStyle() {
      let { height, marginAndPadding, fontWeight } = this;
      let { margin, padding } = marginAndPadding
      if (dsf.isNumber(height) || /^\d+$/g.test(height)) {
        height += "px";
      }

      if (this.isDesign) {
        return {
          margin: 0,
          padding,
          fontWeight: fontWeight,
          boxSizing: "border-box",
        };
      }

      return {
        ...marginAndPadding,
        height,
        fontWeight,
        boxSizing: "border-box",
      };
    },
  },
  data() {
    return {
      // 伪代码事件相关作用域
      eventScope: {},
      //当前组件值
      currentCompentData: {},
      //字数超长策略
      showFeildRules: [
        {
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        },
        {
          overflow: "hidden",
          display: "-webkit-box",
          textOverflow: "ellipsis",
          "-webkit-box-orient": "vertical",
          "-webkit-line-clamp": 2,
        },
      ],
    };
  },
  created() {
    if (this.isDesign) {
      if (!this.fakeCodeName) {
        let it = this;
        //组件名字
        let ctrlName = it.ctrlName;
        let ctrlType = it.ctrlType.split(".")[1];
        //组件ref的后缀
        let sign = it.caption.substr(ctrlType.length);
        let dataviews = window.$components.dataview;
        let chineseName = dataviews[ctrlName].ctrlCaption;
        let name = `${chineseName}${sign}`;
        this.$emit("update:fakeCodeName", name);
      }
    }
  },
  methods: {
    // 获取页面值单位转化列表
    addUnits(data) {
      let obj = dsf.dataview.units
      let list = Object.keys(obj).map((key) => ({
        text: obj[key],
        value: key,
      }));
      list.unshift({
        text: "无",
        value: "",
      });
      data.dictionary = list;
    },
    //获取页面字体列表
    addFonts(data) {
      data.dictionary = dsf.dataview.fonts
    },
    // 兼容src统一使用bgSettingExtend的格式
    compatiblePathToObj(obj, active = "custom") {
      return dsf.dataview.utils.compatiblePathToExtendImg(obj, active);
    },
    // 兼容src并且进行反显
    handleImgSrcStr(obj) {
      return dsf.dataview.utils.compatiblePathToExtendShowImg(obj);
    },
    //单位换算
    transformUnit() {
      return dsf.dataview.utils.transformUnit(...arguments);
    },
    getBorderCss(width, isSolid, color) {
      let border = `${this.transPX(width)} ${isSolid ? "solid" : "dashed"
        } ${color}`;
      return border;
    },
    transformImageWebpath(url) {
      return dsf.dataview.utils.getWebPath.call(this, url);
    },
    $colorFormat(opt) {
      if (!opt) {
        return {};
      }
      let { active, color, pattern, custom } = opt;
      switch (active) {
        case "color":
          let { isTheme, theme, value, type, image } = color;

          if (type == "color") {
            return {
              "background-color": isTheme
                ? dsf.themeConfig.currentTheme[theme]
                : value,
            };
          } else {
            return { background: image };
          }
        case "pattern":
          if (pattern) {
            let imgUrl =
              this.$designer?.getUplaodImageById(pattern.image) ||
              pattern.image; // 当弹框的时候$designer就不存在
            imgUrl = dsf.dataview.utils.getWebPath.call(this, imgUrl);
            return {
              "background-image": imgUrl ? `url('${imgUrl}')` : "none",
              "background-size": pattern.size,
              "background-repeat": pattern.repeat,
              "background-position": pattern.position,
            };
          }
          break;
        case "custom":
          if (custom) {
            return {
              "background-image": `url('${dsf.dataview.utils.getWebPath.call(
                this,
                custom.image
              )}')`,
              "background-size": custom.size,
              "background-repeat": custom.repeat,
              "background-position": custom.position,
            };
          }
      }
      return {};
    },
    /*
      该方法与 $colorFormat 存在差异
      $colorFormat 方法中，单色、背景图、自定义背景图、线性渐变和径向渐变只能存在一种
      $colorFormatCoexist 方法中，单色与背景图/自定义背景图可同时存在， 单色、背景图/自定义背景图与渐变色仍互斥
    */
    $colorFormatCoexist(opt) {
      let config = opt ? opt : this.backgroundConfig;
      let { active, pattern, custom } = config,
        style = {};
      // 添加背景色
      if (active === "color") {
        style = this.$colorFormat({
          ...config,
          active: "color",
        });
        // 添加背景/自定义背景
        if (pattern?.image || custom?.image) {
          style = {
            ...style,
            ...this.$colorFormat({
              ...config,
              active: pattern?.image ? "pattern" : "custom",
            }),
          };
        }
      } else {
        style = {
          ...this.$colorFormat({
            ...config,
            active,
          }),
        };
      }
      return style;
    },
    handleArrPX(arr) {
      if (!Array.isArray(arr)) {
        return arr;
      }
      let list = [];
      list = arr.map((str) => this.transPX(str)).join(" ");
      return list;
    },
    judgeMargin(arr) {
      if (!Array.isArray(arr)) {
        return false;
      }
      if (arr.length) {
        return arr.every((item) => item !== undefined && item !== null);
      }
      return false;
    },
    // 针对设置(bgLayoutArraySetting)属性提取,返回有的属性
    abstractBgArrAttr(obj) {
      // 单个背景
      let bgObj = obj?.bgImgObj || {};
      let background = this.$colorFormatCoexist(bgObj) || {};
      // 单个属性
      let borderRadius = obj?.borderRadius || "";
      let bgMargin = obj?.margin || "";
      let bgPadding = obj?.padding || "";
      let bgWH = obj?.wH || [];
      let style = {
        ...background,
      };
      if (this.judgeMargin(borderRadius)) {
        style.borderRadius = this.handleArrPX(borderRadius);
      }
      if (this.judgeMargin(bgMargin)) {
        style.margin = this.handleArrPX(bgMargin);
      }
      if (this.judgeMargin(bgPadding)) {
        style.padding = this.handleArrPX(bgPadding);
      }
      if (bgWH.length) {
        if (bgWH[0]) {
          style.width = this.transPX(bgWH[0]);
        }
        if (bgWH[1]) {
          style.height = this.transPX(bgWH[1]);
        }
      }
      return style;
    },
    transPX(size) {
      if (dsf.isNumber(size) || /^\d+$/g.test(size)) {
        size += "px";
      }
      return size;
    },
    getColor(color) {
      if (color === "theme") {
        color = "@main";
      }
      return dsf.themeConfig.getThemeColor(color) || color;
    },
    // 获取当前选择风格配置项
    handlerCurrentStyleConfig() {
      let themeName = this.$designer.styleTheme;

      const theme = dsf.dataview.styles.find(
        (it) => it.value === themeName
      );
      if (theme) {
        let style = theme.style;
        let styleMapKey = this.styleMapKey;
        if (style[styleMapKey]) {
          this.styleConfigCallback(style[styleMapKey]);
        }
      }
    },
    styleConfigCallback(options) {
      const keys = Object.keys(this.$props);
      Object.keys(options).forEach((keyName) => {
        if (keys.includes(keyName)) {
          if (/backgroundConfig$/gi.test(keyName)) {
            let background = options[keyName];
            if (
              ["custom", "pattern"].includes(background.active) &&
              background[background.active]
            ) {
              let image = background[background.active].image;
              image = this.$designer.getUplaodImageById(image);
              background[
                background.active
              ].image = dsf.dataview.utils.getWebPath.call(this, image);
            }
            this.$emit(`update:${keyName}`, background);
          } else {
            this.$emit(`update:${keyName}`, options[keyName]);
          }
        }
      });
    },
    // 相关事件作用域处理
    handleEventScope() {
      if (this.executeFnScope && !this.isDesign) {
        this.eventScope = utilsHandleScope(this, this.executeFnScope);
      }
    },
    // 组件伪代码统一入口
    handleCommonEmit(code, data) {
      if (!this.isDesign && code) {
        try {
          let page = this.$page.$vm;
          //给作用域注入 vm page data
          this.eventScope.vm = this;
          this.eventScope.page = page;
          this.eventScope.data = data;
          let query = this.$route.query
          //在viewpart中打开页面-gis运行一张图
          if (page.$frame) {
            let localParams = page.$frame.localParams
            query = { ...query, ...localParams }

          }
          this.eventScope["全局参数"] = page.$dataview;
          this.eventScope["路径参数"] = query

          let callback = utilsHandleParseCode(code);

          callback.call(this, this.eventScope);
        } catch (error) {
          console.warn("伪代码执行失败", error);
        }
      }
    },

    //请求
    handleHTTP(url, method = "get", params = null, config = null) {
      return this.$http[method](this.$replace(url, this.local), params, config);
    },
    //显示
    handleShow() {
      this.$el.style.display = "block";
      if (typeof this.resize == "function") {
        this.$nextTick(this.resize);
      }
    },
    //隐藏
    handleHidden() {
      this.$el.style.display = "none";
      return this;
    },
    //获取组件当前值
    handleGetValue() {
      return this.currentCompentData;
    },
    //公共页面事件
    handleTurnPage(url) {
      let target = url;
      if (dsf.isString(url)) {
        if (!url.startsWith("/")) {
          url = "/" + url;
        }
        target = {
          path: url,
        };
      }
      this.$router.push(target);
      return this;
    },
    //打开大屏弹框
    handleOpenDataViewDialog(url, width = "50%", height = "300px", title = "", type) {
      let dialogConfig = this.$page ? this.$page.dialogConfig : this.dialogConfig
      if (!dialogConfig) return false
      let style = dialogConfig.find(it => it.id === type)
      if (!style) {
        style = dialogConfig[0]
      }
      let options = {
        title,
        params: {
          path: ""
        },
        width,
        height
      }
      if (dsf.isString(url)) {
        if (!url.startsWith("/")) {
          url = "/" + url;
        }
        options.params.path = url
      } else if(dsf.isObject(url)) {
        options = url
      }
      let openDialog = dsf.dataview.layer.openDialog.bind(this);
      openDialog(options, style);
    },
    //打开弹框
    handleOpenDialog(url, width = "900px", height = "60vh") {
      if (dsf.isString(url)) {
        if (!url.startsWith("/")) {
          url = "/" + url;
        }
      }
      this.$openDialog({
        title,
        width,
        height,
        params: {
          path: url,
        },
        btns: [],
      });
      return this;
    },
  },
};
